import { render, staticRenderFns } from "./ysqxslist.vue?vue&type=template&id=7d31d058&scoped=true"
import script from "./ysqxslist.vue?vue&type=script&lang=js"
export * from "./ysqxslist.vue?vue&type=script&lang=js"
import style0 from "./ysqxslist.vue?vue&type=style&index=0&id=7d31d058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d31d058",
  null
  
)

export default component.exports